// Theme configurations for 3Dragons

export const themes = {
  darkLuxury: {
    name: 'Dark Luxury',
    colors: {
      // Background
      bodyBg: 'linear-gradient(135deg, #0a0e27 0%, #1a1d3e 50%, #0f1328 100%)',
      headerBg: 'linear-gradient(90deg, rgba(20, 25, 50, 0.98) 0%, rgba(30, 35, 70, 0.98) 100%)',
      headerBorder: '2px solid rgba(100, 255, 218, 0.3)',
      cardBg: 'rgba(20, 25, 45, 0.8)',
      cardBorder: '1px solid rgba(100, 255, 218, 0.2)',
      
      // Text
      textPrimary: '#ffffff',
      textSecondary: '#a0aec0',
      textMuted: '#718096',
      
      // Accents
      primary: '#64ffda',
      primaryHover: '#4fd6b8',
      success: '#00ff88',
      danger: '#ff006e',
      warning: '#ffbe0b',
      
      // Buttons
      buttonBg: 'linear-gradient(135deg, #64ffda 0%, #4fd6b8 100%)',
      buttonText: '#0a0e27',
      buttonHover: 'linear-gradient(135deg, #4fd6b8 0%, #3dbfa0 100%)',
      
      // Glass effect
      glassBg: 'rgba(255, 255, 255, 0.05)',
      glassBlur: 'blur(10px)',
      glassBorder: '1px solid rgba(255, 255, 255, 0.1)',
      
      // Shadows
      cardShadow: '0 8px 32px rgba(100, 255, 218, 0.1)',
      buttonShadow: '0 4px 20px rgba(100, 255, 218, 0.3)',
    }
  }
};

export default themes;

